import { useI18next } from "gatsby-plugin-react-i18next"
import styled, { css } from "styled-components"

import DropDown2 from "components/dropDowns/DropDown2"
import ImageSequence from "components/ImageSequence"
import InnerWrapper from "components/InnerWrapper"
import Callout from "components/TextElements/Callout"
import media from "styles/media"
import text from "styles/text"
import { fmobile, fresponsive, ftablet } from "utils/fullyResponsive"
import useMedia from "utils/useMedia"

export default function DigitalFirst() {
  const { t } = useI18next()

  const dropDowns = DropData.map(dropd => (
    <DropDown2 key={dropd.title} data={dropd} />
  ))

  return (
    <Wrapper id="digital-first">
      <InnerWrapper setWidth={useMedia("1440px", "100%", "100%", "100%")} flex>
        <InnerInnerWrapper>
          <ImageWrapper>
            <LargeImage
              trigger="#digital-first"
              folder="digital-first"
              length={185}
              startVal="top 20%"
              frame={0}
            />
          </ImageWrapper>
          <Stuff>
            <Callout
              variant="lightmode"
              title={{
                content: t("Digital-first experiences for businesses."),
                size: useMedia(text.h4, text.h4, text.h5, text.h1Mobile),
                width: "100%",
              }}
              text={{
                content: t(
                  "We help founders and builders create new businesses that are part of and help shape the new payments world."
                ),
                width: "100%",
              }}
            />
            <Margin />
            {dropDowns}
          </Stuff>
        </InnerInnerWrapper>
      </InnerWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`
const InnerInnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;

  ${fresponsive(css`
    padding: 60px 129px;
  `)}

  ${media.tablet} {
    flex-direction: column;
    align-items: center;
  }

  ${fmobile(css`
    padding: 80px 20px;
    flex-direction: column;
    align-items: center;
  `)}
`

const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  flex-grow: 0;

  ${fresponsive(css`
    width: 626px;
    height: 800px;
  `)}

  ${fmobile(css`
    width: 335px;
    height: 428px;
  `)}
`

const LargeImage = styled(ImageSequence)`
  height: 100%;
  width: 100%;
  isolation: isolate;

  ${fresponsive(css`
    border-radius: 120px;
  `)}

  ${ftablet(css`
    border-radius: 80px;
  `)}

  ${fmobile(css`
    border-radius: 40px;
  `)}

  display: flex;
  flex-direction: column;
  align-items: center;
  object-fit: cover;
`

const Stuff = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;

  ${media.fullWidth} {
    padding: 141.5px 109px;
    padding-right: 0;
  }
  ${media.desktop} {
    padding: 8.524vw 6.566vw;
  }

  ${ftablet(css`
    padding: 100px 0px;
  `)}

  ${fmobile(css`
    padding: 40px 0px;
  `)}
`

const Margin = styled.div`
  ${media.fullWidth} {
    margin-top: 40px;
  }
  ${media.desktop} {
    margin-top: 2.41vw;
  }
  ${media.tablet} {
    margin-top: 3.906vw;
  }
  ${media.mobile} {
    margin-top: 10.667vw;
  }
`

const DropData = [
  {
    title: "MONEY IN",
    list: [
      {name:"1. ACH",link:"https://docs.galileo-ft.com/pro/docs/ach-at-galileo"},
      {name:"2. Same-Day ACH",link:"https://docs.galileo-ft.com/pro/docs/ach-at-galileo#same-day-ach"},
      {name:"3. Checks",link:"https://docs.galileo-ft.com/pro/docs/business-banking-fundamentals#small-business-debit-cards-business-checking"}
    ],
  },
  {
    title: "MANAGE MONEY",
    list: [
      {name:"1. Business Account",link:"https://docs.galileo-ft.com/pro/docs/business-banking-programs"},
      {name:"2. Secondary Accounts", link:"https://docs.galileo-ft.com/pro/docs/about-accounts#secondary-accounts"},
      {name:"3. Overdraft",link:"https://docs.galileo-ft.com/pro/docs/overdraft-operational-setup"},
      {name:"4. Account Level Authorization Controls",link:"https://docs.galileo-ft.com/pro/docs/account-level-auth-controls"},
      {name:"5. Expense Management",link:"https://docs.galileo-ft.com/pro/docs/business-banking-fundamentals#corporate-travel-and-expense-cards"},
     {name:"6. Corporate Hierarchy ",link:"https://docs.galileo-ft.com/pro/docs/about-corporate-hierarchy"},
     {name:"7. Fleet Cards",link:"https://docs.galileo-ft.com/pro/docs/fleet-cards"}
    ],
  },
  {
    title: "MONEY OUT",
    list: [
     {name: "1. ACH",link:"https://docs.galileo-ft.com/pro/docs/ach-at-galileo"},
     {name:"2. Checks",link:"https://docs.galileo-ft.com/pro/docs/choose-a-card-strategy#digital-cards"},
     {name:"3. Physical & Virtual Cards",link:"https://docs.galileo-ft.com/pro/docs/choose-a-card-strategy#physical-cards"},
     {name:"4. Real-Time Funding and more",link:"https://docs.galileo-ft.com/pro/docs/real-time-funding"}
    ],
  },
]
